import { useState, useEffect } from "react";

interface UseCountdownProps {
  endTime: string | undefined;
  noActivePeriod: boolean;
  turnedIn: boolean;
}

export const useCountdown = ({ endTime, noActivePeriod, turnedIn }: UseCountdownProps) => {
  const [countdown, setCountdown] = useState("");

  useEffect(() => {
    if (!endTime || noActivePeriod || turnedIn) {
      setCountdown("");
      return;
    }
    
    const update = () => {
      const end = new Date(endTime).getTime();
      const diff = end - Date.now();
      
      if (diff <= 0) {
        setCountdown("Period closed");
        return;
      }
      
      const days = Math.floor(diff / 86400000);
      const hours = Math.floor((diff % 86400000) / 3600000);
      const mins = Math.floor((diff % 3600000) / 60000);
      setCountdown(`${days}d ${hours}h ${mins}m remaining`);
    };
    
    update();
    const id = setInterval(update, 60000);
    return () => clearInterval(id);
  }, [endTime, noActivePeriod, turnedIn]);

  return countdown;
};
